import { createSelector } from 'reselect';

const getLoadingStates = state => state.loading.states;
const getReservation = state => state.reservation;
const getFees = state => state.fees;
const getDonations = state => state.donations;

export const getLoadingLevels = createSelector([getLoadingStates], (states) => {
    let levels = [];

    Object.keys(states).map((key, i) => {
        let match = /TICKET_QUANTITY_([0-9]+)/.exec(key);
        if (match && states[key] === "REQUEST") {
            levels.push(+match[1]); // cast to int
        }
    });

    return levels;
});


export const getLoadingProductConfig = createSelector([getLoadingStates], (states) => {
    let configurations = [];

    Object.keys(states).map((key, i) => {

        let match = /PRODUCT_QUANTITY_([0-9]+)/.exec(key);
        if (match && states[key] === "REQUEST") {
            configurations.push(+match[1]); // cast to int
        }
    });

    return configurations;
});

export const getLoadingBundles = createSelector([getLoadingStates], (states) => {
    let bundles = [];

    Object.keys(states).map((key, i) => {
        let match = /BUNDLE_QUANTITY_([0-9]+)/.exec(key);
        if (match && states[key] === "REQUEST") {
            bundles.push(+match[1]); // cast to int
        }
    });

    return bundles;
});

export const getOrderTotal = createSelector([getReservation, getFees, getDonations], (reservation, fees, donations) => {
    if(!reservation.token) {
        return {amount: 0};
    }

    let amount = reservation.total_cost.amount;

    if (Object.keys(fees.insuranceFee).length > 0) {
        amount += fees.insuranceFee.amount;
    }

    if (Object.keys(fees.deliveryFee).length > 0) {
        if (reservation.total_delivery_fees && reservation.total_delivery_fees.amount > 0) {
            amount -= reservation.total_delivery_fees.amount;
        }

        amount += fees.deliveryFee.amount;
    }

    if (reservation.total_donation !== donations.totalReservationDonation) {
        amount += (donations.totalReservationDonation || 0) - (reservation.total_donation || 0);
    }
    

    return { ...reservation.total_cost, amount };
});

export const getNumItemsInCart = createSelector([getReservation], (reservation) => {
    return reservation.items_count;
});
